import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";
import { usePricePlan } from "../store/PricePlanContext";
import SiteHeader from "../Components/SiteHeader";

const PricePlan = () => {
  const { updateSelectedPlan, pricingData } = usePricePlan();
  
  // Helper to get pricing info for a term
  const getPricingInfo = (term) => {
    if (pricingData && pricingData[term] && pricingData[term].length > 0) {
      const termData = pricingData[term];
      const durations = termData.map(p => p.duration).sort((a, b) => a - b);
      const prices = termData.map(p => p.price);
      const minDuration = durations[0];
      let maxDuration = durations[durations.length - 1];
      // Ensure mid-term always shows max of 11 months
      if (term === 'mid-term') {
        maxDuration = 11;
      }
      const minPrice = Math.min(...prices);
      const unit = termData[0].unit;
      
      return {
        min: minDuration,
        max: maxDuration,
        unit: unit + 's',
        price: minPrice
      };
    }
    // Fallback to hardcoded values
    const fallback = {
      'special': { min: 1, max: 6, unit: 'days', price: 80 },
      'short-term': { min: 1, max: 3, unit: 'weeks', price: 200 },
      'mid-term': { min: 1, max: 11, unit: 'months', price: 350 },
      'long-term': { min: 1, max: 2, unit: 'years', price: 600 }
    };
    return fallback[term] || fallback['special'];
  };

  const handlePlanSelect = (name, duration, price, term) => {
    updateSelectedPlan({
      name,
      duration,
      price,
      term
    });
  };

  return (
    <>
    <SiteHeader />
    <div className="price-plan-container">

      <div className="price-plan-header">
        <h1>Select Time-Frame</h1>
        {/* <h3>Lorem ipsum dolor sit amet.</h3> */}
      </div>

      <div className="price-plan">
        <div className="price-card">
          <div className="plan-name">
            <h3>Special Occasions</h3>
          </div>
          <div className="plan-duration">
            <h1>{getPricingInfo('special').min}-{getPricingInfo('special').max}</h1>
            <h3>{getPricingInfo('special').unit}</h3>
          </div>
          <hr />
          <div className="plan-price">
            <p>STARTING FROM</p>
            <h2>R {Math.round(getPricingInfo('special').price)}</h2>
          </div>
          <div className="button">
            <NavLink to="/advertise/special/help" onClick={() => {
              const info = getPricingInfo('special');
              handlePlanSelect('Special Occasions', `${info.min}-${info.max} ${info.unit}`, `R ${Math.round(info.price)}`, 'special');
            }}>
              <Button>START NOW</Button>
            </NavLink>
          </div>
        </div>

        <div className="price-card">
          <div className="plan-name">
            <h3>short term</h3>
          </div>
          <div className="plan-duration">
            <h1>{getPricingInfo('short-term').min}-{getPricingInfo('short-term').max}</h1>
            <h3>{getPricingInfo('short-term').unit}</h3>
          </div>
          <hr />
          <div className="plan-price">
            <p>STARTING FROM</p>
            <h2>R {Math.round(getPricingInfo('short-term').price)}</h2>
          </div>
          <div className="button">
            <NavLink to="/advertise/short-term/help" onClick={() => {
              const info = getPricingInfo('short-term');
              handlePlanSelect('Short Term', `${info.min}-${info.max} ${info.unit}`, `R ${Math.round(info.price)}`, 'short-term');
            }}>
              <Button>START NOW</Button>
            </NavLink>
          </div>
        </div>

        <div className="price-card">
          <div className="plan-name">
            <h3>mid term</h3>
          </div>
          <div className="plan-duration">
            <h1>{getPricingInfo('mid-term').min}-{getPricingInfo('mid-term').max}</h1>
            <h3>{getPricingInfo('mid-term').unit}</h3>
          </div>
          <hr />
          <div className="plan-price">
            <p>STARTING FROM</p>
            <h2>R {Math.round(getPricingInfo('mid-term').price)}</h2>
          </div>
          <div className="button">
            <NavLink to="/advertise/mid-term/help" onClick={() => {
              const info = getPricingInfo('mid-term');
              handlePlanSelect('Mid Term', `${info.min}-${info.max} ${info.unit}`, `R ${Math.round(info.price)}`, 'mid-term');
            }}>
              <Button>START NOW</Button>
            </NavLink>
          </div>
        </div>

        <div className="price-card">
          <div className="plan-name">
            <h3 style={{ color: "#fff" }}>long term</h3>
          </div>
          <div className="plan-duration">
            <h1 style={{ color: "#fff" }} >{getPricingInfo('long-term').min}-{getPricingInfo('long-term').max}</h1>
            <h3 style={{ color: "#fff" }}>{getPricingInfo('long-term').unit}</h3>
          </div>
          <hr style={{ color: "#fff" }} />
          <div className="plan-price">
            <p style={{ color: "#fff" }} >STARTING FROM</p>
            <h2 style={{ color: "#fff" }} >R {Math.round(getPricingInfo('long-term').price)}</h2>
          </div>
          <div className="button">
            <NavLink to="/advertise/long-term/help" onClick={() => {
              const info = getPricingInfo('long-term');
              handlePlanSelect('Long Term', `${info.min}-${info.max} ${info.unit}`, `R ${Math.round(info.price)}`, 'long-term');
            }}>
              <Button>START NOW</Button>
            </NavLink>
          </div>
        </div>
      </div>

    </div>
    </>
  )
}

export default PricePlan